<template>
  <div>
    <section class="app-section filterAnalysis">
      <div class="card">
        <Form :label-width="90">
          <FormItem label="填写时间">
            <DatePicker
              :value="date"
              type="daterange"
              format="yyyy-MM-dd"
              :options="options"
              placement="bottom-end"
              placeholder="请选择填写时间"
              style="width:50%"
              @on-change="handleChange"
              confirm
              clearable
              @on-clear="cleaDate"
            ></DatePicker>
          </FormItem>
          <div style="display:flex">
            <FormItem label="性别">
              <Select v-model="sex" style="width:130px">
                <Option
                  v-for="item in sexList"
                  :value="item.value"
                  :key="item.value"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
            <FormItem label="年龄" style="width:200px;flex:1">
              <Input v-model="age1" placeholder="岁" style="width: 100px" />&nbsp;--
              <Input v-model="age2" placeholder="岁" style="width: 100px" />
            </FormItem>
          </div>
        </Form>
      </div>

      <div class="card" style="margin-top:15px">
        <div class="patient-analysis">
          <div class="left">
            <div
              class="out-container"
              :class="{ 'out-container-line': list.length > 2 && index !== list.length-1 ,
          'out-container__active': activeItem === index,
          'out-container__short': list.length < 3
           }"
              v-for="(i, index) in list"
              :key="index"
              @click="handleItem(i, index)"
            >
              <div class="out-container-cover" v-if="index === list.length - 2"></div>

              <div class="out-relationship-select" v-if="index !== list.length - 2">
                <Select v-model="i.associatOperator" style="width: 60px">
                  <Option
                    v-for="it in relationships"
                    :value="it.value"
                    :key="it.value"
                  >{{ it.label }}</Option>
                </Select>
              </div>
              <div
                :class="{
            'out-container-context':activeItem === index
          }"
                class="out-container-body"
              >
                <span v-if="!i.hasOwnProperty('questionId') && index != 0" class="add-item">+新增问卷条件</span>
                <span v-else class="out-container-title">
                  <span>{{ i.name || '未命名'}}</span>

                  <i class="el-icon-delete" @click.stop="onDelete(index)" style="margin-left:20px"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="right">
            <condition-filter
              :childList="childList"
              :activeItem="activeItem"
              :category_id="category_id"
              @childData="childData"
            />
          </div>
        </div>

        <div style="padding-left:200px;margin:20px 0">
          <Button type="primary" round @click="onFilter()">筛查</Button>
          <Button style="margin:0 20px" round @click="reset()">重置</Button>
        </div>
      </div>

      <div class="card" style="margin-top:15px" v-if="search">
        <div class="report_t" style="color: #ffa615;font-weight: bold;margin: 10px 0 20px;">
          <i></i>
          筛选结果
        </div>

        <!-- 指标分析暂时隐藏 -->
        <Tabs :animated="false">
          <TabPane
            type="border-card"
            v-for="(i, index) in queryList"
            :key="'tab_' + index"
            :label="i.title"
            :name="i.title"
          >
            <div style="position:relative;margin-top:16px;">
              <CustomQuery
                v-if="i.name === 'personnel'"
                :params="params"
                :type="0"
                @AnalysiList="AnalysiList"
              ></CustomQuery>
              <search-report
                v-if="i.name === 'questionnaire' "
                :quesList="analysis_list"
                :list_info="list_info"
              ></search-report>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </section>
  </div>
</template>

<script>
import ConditionFilter from './components/ConditionFilter.vue'
import CustomQuery from './components/customQuery'
import searchReport from './components/searchReport'
export default {
  name: 'filterAnalysis',
  data() {
    return {
      date: '',
      group: [],
      options: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now()
        },
        shortcuts: [
          {
            text: '近一周',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              return [start, end]
            },
          },
          {
            text: '近一个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              return [start, end]
            },
          },
          {
            text: '近三个月',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end]
            },
          },
        ],
      },
      sex: '',
      sexList: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '男',
        },
        {
          value: '0',
          label: '女',
        },
      ],
      age1: '',
      age2: '',
      activeItem: 0,
      list: [
        {
          questionId: '',
          name: '',
          moduleIndex: 0,
          questions: [],
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        },
        {
          name: '',
        },
      ],
      associatOperator: '与',
      relationships: [
        {
          label: '或',
          value: '或',
        },
        {
          label: '与',
          value: '与',
        },
      ],
      queryList: [
        {
          name: 'personnel',
          title: '人员',
        },
        {
          name: 'questionnaire',
          title: '指标分析',
        },
      ],
      childList: [],
      search: false,
      params: {},
      category_id: '2',
      analysis_list: [],
      list_info: [],
    }
  },
  computed: {},
  components: {
    ConditionFilter,
    CustomQuery,
    searchReport,
  },
  methods: {
    cleaDate: function (date) {
      this.date = []
    },
    AnalysiList(data) {
      console.log(data)
      this.analysis_list = data.analysis_list
      this.list_info = data.list
    },
    handleChange(date) {
      console.log(date)
      this.date = date
    },
    handleItem(i, index) {
      console.log(i, '新增条件', index)
      this.activeItem = index
      if (index === this.list.length - 1) {
        this.list.splice(this.list.length - 1, 0, {
          questionId: '',
          name: '',
          questions: [],
          moduleIndex: index,
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        })
      }

      this.childList = this.list[this.activeItem]
    },
    reset: function () {
      // 重置
      this.activeItem = 0
      let listReset = [
        {
          questionId: '',
          name: '',
          moduleIndex: 0,
          questions: [],
          associatOperator: '与',
          moduleQueryList: [
            {
              associatOperator: '或',
              conditionList: [
                {
                  associatOperator: '或',
                  conditionContent: '',
                  conditionIndex: 0,
                  operator: '',
                  subjectId: '',
                },
              ],
              moduleIndex: 0,
            },
          ],
        },
        {
          name: '',
        },
      ]
      this.list = listReset
      this.childList = this.list[0]
      this.search = false
    },
    childData(data) {
      this.list[this.activeItem] = {
        questionId: '',
        name: '',
        moduleIndex: 0,
        questions: [],
        associatOperator: '与',
        moduleQueryList: [
          {
            associatOperator: '或',
            conditionList: [
              {
                associatOperator: '或',
                conditionContent: '',
                conditionIndex: 0,
                operator: '',
                subjectId: '',
              },
            ],
            moduleIndex: 0,
          },
        ],
      }
      this.childList = this.list[this.activeItem]
      this.search = false
    },
    onFilter: function () {
      let lists = JSON.parse(JSON.stringify(this.list))
      lists.pop()
      // let lists = this.list.filter((l, i) => i !== this.list.length - 1)

      this.search = false
      if (!lists[0].questionId) {
        this.$Message.warning('请选择问卷条件')
        return
      }
      let flag = false

      console.log(lists)
      // return
      lists.forEach((v) => {
        v.moduleQueryList.forEach((m) => {
          m.conditionList.forEach((j) => {
            if (j.subjectId == '') {
              flag = true
            }

            if (typeof j['subjectId'] == 'object') {
              j['subjectId'] = j['subjectId'].join('||')
            }
            if (j.hasOwnProperty('multipleType')) {
              delete j.multipleType
            }
            if (j.hasOwnProperty('digital')) {
              delete j.digital
            }
            if (j.hasOwnProperty('mulity')) {
              delete j.mulity
            }
            if (j.hasOwnProperty('multiple')) {
              delete j.multiple
            }
            if (j.hasOwnProperty('options')) {
              delete j.options
            }
            if (j.hasOwnProperty('single_options')) {
              delete j.single_options
            }
            if (j.hasOwnProperty('oneShip')) {
              delete j.oneShip
            }
            if (j['betweenShip']) {
              j.conditionContent =
                j.conditionContent1 + '||' + j.conditionContent2
              delete j.conditionContent1
              delete j.conditionContent2
              delete j.betweenShip
            } else {
              delete j.betweenShip
            }

            if (j['conditionContent']) {
              if (j['conditionContent1'] && j['conditionContent2']) {
                delete j['conditionContent1']
                delete j['conditionContent2']
              }
              if (typeof j.conditionContent == 'object') {
                 j['conditionContent'] = j['conditionContent'].join('||')
               }
            }
          })
        })
      })
      if (flag) {
        this.$Message.warning('请选择问卷条件')
        return
      }
      let obj = {
        begin_time: this.date[0] ? this.date[0] + ' 00:00:00' : '',
        end_time: this.date[1] ? this.date[1] + ' 23:59:59' : '',
        gender: this.sex,
        min_age: this.age1,
        max_age: this.age2,
        template: {
          templateName: '筛查模版',
          moduleQueryList: lists,
        },
        need_page: 1,
      }
      this.search = true
      this.params = obj
    },
    onDelete: function (index) {
      if (this.list.length == 2) {
        this.$Message.warning('已经到第一个了')
        return
      }
      this.list.splice(index, 1)
      this.activeItem = this.list.length - 2
      this.childList = this.list[this.activeItem]
    },
  },
  created() {
    this.childList = this.list[0]
  },
  mounted() {},
  watch: {},
}
</script>

<style lang="less" scoped>
.filterAnalysis {
  // background-color: @background-color;

  .ivu-tabs-bar {
    margin-bottom: 0;
  }
  .report_t {
    i {
      width: 5px;
      height: 13px;
      background: #ffa615;
      border-radius: 5px;
      display: inline-block;
      margin-right: 6px;
    }
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .card {
    background: #fff;
    padding: 20px 10px;
  }
  .patient-analysis {
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    .right {
      flex: 1;
    }
  }
  .out-container__short {
    margin-left: 5px !important;
    transition: all 0.5s;
  }
  .out-container {
    margin-left: 100px;
    transition: all 0.5s;
    // background-color: #f9f6ff;
    padding: 10px 15px;
    border: solid 1px #e3e3e3;
    height: 70px;
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    & + .out-container {
      border-top: none;
    }
    &__active {
      border: 1px solid #2d8cf0 !important;
      border-right: none;
      background: #f6f9ff;
      position: relative;
    }
    &-line {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: -60px;
        width: 60px;
        border-bottom: solid 1.5px #e0e0e0;
        margin-top: -0.5px;
      }

      &:before {
        content: '';
        position: absolute;
        left: -60px;
        top: 50%;
        bottom: -1000px;
        border-left: solid 1.5px #e0e0e0;
      }
    }
    .out-container-body {
      .add-item {
        color: #2d8cf0;
      }
      .out-container-title {
        display: flex;
        span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 151px;
          text-align: center;
        }
        i {
          flex: 1;
        }
      }
    }
    .out-container-context {
      &::after {
        content: '';
        position: absolute;
        top: 0px;
        right: -3px;
        width: 5px;
        height: 68px;
        background: #f6f9ff;
        z-index: 999;
      }
    }
    .out-container-cover {
      position: absolute;
      top: 50%;
      left: -60px;
      width: 5px;
      height: 1000px;
      background-color: #fff;
      margin-top: 1px;
    }
    .out-relationship-select {
      position: absolute;
      left: -90px;
      top: 50%;
      margin-top: 20px;
    }
  }
}
</style>
